export default __webpack_public_path__ + "static/media/74.ff0ad6ae.png";